/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
/**
 * SSR-mode frontend entry.
 * Hydrates the main app, including the html/head/body elements.
 * The server renders the stylesheet and preload tags this entry needs.
 */
import "@vitejs/plugin-react/preamble";
import "../../styles/index.css";
import "./manifest/blocks";
import "./manifest/views";

import { SSRClientRoot } from "eddev/_internal/ssr-root-client.js";
import { devToolsStore } from "eddev/devtools";
import * as React from "react";
import { hydrateRoot, Root } from "react-dom/client";

// Skew protection
const updateSkewCookie = () => {
  document.cookie = "__vdpl=dpl_DzbsjW8F2ZSBSDkKebjc1Wh359i1; expires=" +
    new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/";
};
window.onfocus = updateSkewCookie;
updateSkewCookie();

// Set up a dynamic entry which will load the configured tailwind manifest
devToolsStore.loadTailwindConfig = () => import("./manifest/tailwind-config.js");

window.$reactRoot = window.$reactRoot || hydrateRoot(
  document.getElementById("root")!,
  <React.Suspense>
    <SSRClientRoot metaTags={window._PAGE_DATA?.meta?.head} />
  </React.Suspense>,
  { identifierPrefix: "ed" },
);

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    if (mod) {
      const app = (
        <React.Suspense>
          <SSRClientRoot metaTags={window._PAGE_DATA?.meta?.head} />
        </React.Suspense>
      );
      window.$reactRoot?.render(app);
    }
  });
}

declare global {
  interface Window {
    $reactRoot?: Root;
    _PAGE_DATA: any;
  }
}
